import { IDynamicFilters } from "../types/type-plp-filters.types";
import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

interface DynamicFiltersApiResponse {
  data: IDynamicFilters[];
}

export const getDynamicFiltersData = async (
  sectionValue: string
): Promise<DynamicFiltersApiResponse> => {
  try {
    const response: IResponse<DynamicFiltersApiResponse> = await encryptedRequest({
      method: "POST",
      url: API_PATHS.dynamicFilters,
      data: {
        sectionValue,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Error in Dynamic Filters", err);
    return {} as DynamicFiltersApiResponse;
  }
};
